const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function trackClick({ film, platform, action = 'click', section = 'experience' }) {
  // Fire and forget — don't block the user
  fetch(`${API}/track`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ film, platform, action, section }),
  }).catch(() => {});
}
